// src/theme.ts
import {
  createSystem,
  defaultConfig,
  defineConfig,
  mergeConfigs,
} from "@chakra-ui/react";

// Define our custom configuration
const customConfig = defineConfig({
  theme: {
    tokens: {
      colors: {
        brand: {
          50: { value: "#E3F2F9" },
          100: { value: "#C5E4F3" },
          200: { value: "#A2D4EC" },
          300: { value: "#7AC1E4" },
          400: { value: "#FF715B" },
          500: { value: "#53BA5B" }, // Main brand color
          600: { value: "#32544A" },
          700: { value: "#1D4338" },
          800: { value: "#005885" },
          900: { value: "#003F5E" },
        },
      },
      fonts: {
        heading: { value: "Lexend, sans-serif" },
        body: { value: "Lexend, sans-serif" },
      },
    },
    recipes: {
      Button: {
        variants: {
          variant: {
            solid: {
              bg: "brand.500",
              _hover: { bg: "brand.600" },
              fontWeight: "bold",
            },
          },
        },
      },
    },
    semanticTokens: {
      colors: {
        "app.bg": { value: "gray.50" },
        "app.text": { value: "gray.800" },
      },
    },
  },
});

// Merge with default configuration
const mergedConfig = mergeConfigs(defaultConfig, customConfig);

// Create the system with our configuration
const system = createSystem(mergedConfig, {
  cssVarsPrefix: "greenflip",
});

export default system;
